import { render, staticRenderFns } from "./google-form.vue?vue&type=template&id=c6263ae6"
import script from "./google-form.vue?vue&type=script&lang=js"
export * from "./google-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports